import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.element.addEventListener('pointerdown', this.onPointerDown);
  }

  disconnect() {
    this.element.removeEventListener('pointerdown', this.onPointerDown);
    this.stopDragging();
  }

  onPointerDown(event) {
    const handle = event.target.closest('.rb-room-location__drag');
    if (!handle || !this.element.contains(handle)) return;
    if (event.button !== 0) return;

    event.preventDefault();
    event.stopPropagation();

    this.section = handle.closest('.rb-room-location');
    if (!this.section) return;

    this.startOrder = this.locationIds();
    this.section.classList.add('is-dragging');
    handle.setPointerCapture(event.pointerId);

    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    window.addEventListener('pointercancel', this.onPointerUp);
  }

  onPointerMove(event) {
    if (!this.section) return;

    const others = this.sections().filter((section) => section !== this.section);
    const insertBefore = others.find((other) => {
      const box = other.getBoundingClientRect();
      return event.clientY < box.top + box.height / 2;
    });

    if (insertBefore) {
      if (insertBefore.previousElementSibling !== this.section) {
        insertBefore.before(this.section);
      }
      return;
    }

    const last = others[others.length - 1];
    if (last && last.nextElementSibling !== this.section) {
      last.after(this.section);
    }
  }

  onPointerUp() {
    if (!this.section) return;

    const changed = this.locationIds().join() !== this.startOrder.join();
    this.stopDragging();
    if (changed) this.persist();
  }

  stopDragging() {
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    window.removeEventListener('pointercancel', this.onPointerUp);

    if (this.section) this.section.classList.remove('is-dragging');
    this.section = null;
    this.startOrder = null;
  }

  sections() {
    return Array.from(
      this.element.querySelectorAll(':scope > .rb-room-location')
    );
  }

  locationIds() {
    return this.sections()
      .map((section) => section.dataset.locationId)
      .filter(Boolean);
  }

  persist() {
    const ids = this.locationIds();
    if (!ids.length || !this.hasUrlValue) return;

    const token = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = new URLSearchParams();
    ids.forEach((id) => body.append('location_ids[]', id));

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': token,
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    })
      .then((response) => {
        if (!response.ok) {
          window.location.reload();
          return;
        }

        this.updateOrderLabels();
      })
      .catch(() => {
        window.location.reload();
      });
  }

  updateOrderLabels() {
    this.sections().forEach((section, index) => {
      const label = section.querySelector('[data-location-order-label]');
      if (label) label.textContent = `Order ${index + 1}`;
    });
  }
}
